import styled from 'styled-components';

import { TextInput } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const Container = styled.div`
  margin-bottom: 12px;
`;

export const SearchInput = styled(TextInput)`
  height: 34px;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid ${ct({ Light: Colors.GreyDarkerMiddle, Dark: Colors.GreyDarkerMiddle })};
  color: ${ct({ Light: Colors.DarkerText, Dark: Colors.DarkerText })};
  & > div {
    padding: 0 20px;
  }
`;
